// extracted by mini-css-extract-plugin
export default {"fontSizeSmall":"info-icon__fontSizeSmall___nOj3K"};